import cx from 'classnames';
import {useMemo} from 'react';

import {Button, ButtonProps, IconColor, Icon, IconName, IconSize} from 'components';

type Props = {
    action: 'create' | 'delete',
    icon?: IconName;
    hideIcon?: boolean;
} & Omit<ButtonProps, 'icon'>;

export const ActionButton: React.FC<Props> = ({action, icon, hideIcon, className, ...rest}: Props) => {

    const actionsConfig: Record<string, {
        iconProps: {name: IconName, color: IconColor, size: IconSize};
        buttonClass: string;
    }> = useMemo(() => ({
        create: {
            iconProps: {name: icon || 'plus', color: 'primary', size: 'sm'},
            buttonClass: 'tw-border-primary hover:tw-text-primary'
        },
        delete: {
            iconProps: {name: icon || 'delete', color: 'alert', size: 'sm'},
            buttonClass: 'tw-border-alert hover:tw-text-alert'
        }
    }), [icon]);

    const config = useMemo(() => actionsConfig[action], [action, actionsConfig]);

    return (
        <Button
            color='unstyled'
            className={cx(className, rest.disabled ? null : config.buttonClass)}
            Icon={!hideIcon && <Icon {...config.iconProps} className='tw-mr-1' {...(rest.disabled && {color: 'default-dimmed'})} />}
            {...rest}
        />
    );
};